import React from 'react';

import { StepContext, type StepContextType } from './stepContext';

export const useStepContext = (): StepContextType => {
  const context = React.useContext(StepContext);
  if (!context) {
    throw new Error('useStepContext must be used within a StepContextProvider');
  }
  return context;
};
